import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography, ButtonBase } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { VEHICLE_TABS_TYPES, AUCTION_STATUSES } from '../constants';

const StyledTypography = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  padding: ${props => props.isActive ? '23px 13px 20px 13px' : '23px 13px'};
  border-bottom: ${props => props.isActive ? '3px solid #212121' : 'none'};
`;

class Tabs extends Component {
  state = { initiallyLoaded: false };

  componentDidMount() {
    const { setPage, fetchList, page, perPage, auctionStatus, countersLoaded, history, loadCounters } = this.props;
    const isUserUsedBackButton = history.action === "POP";

    if (!countersLoaded || !isUserUsedBackButton) {
      loadCounters();
    } else if (isUserUsedBackButton) {
      setPage(1);
      fetchList({
        status: auctionStatus,
        params: { limit: page * perPage, offset: 1 }
      });
      setPage(2);
    }
  }

  componentDidUpdate(prevProps) {
    const newProps = this.props;
    const { initiallyLoaded } = this.state;
    const countersChanged = newProps.countersLoaded && prevProps.countersLoading !== newProps.countersLoading;

    if (!countersChanged) return ;

    const { [VEHICLE_TABS_TYPES.ACTIVE]: inProgressCounter, [VEHICLE_TABS_TYPES.PENDING]: pendingCounter, auction } = newProps.counters;

    const isAuctionEnded = auction && auction.status === AUCTION_STATUSES.ENDED;
    const isInProgressCounter = Boolean(inProgressCounter);
    const isPendingCounter = Boolean(pendingCounter);

    const isAuctionEndedAndNoCounters = isAuctionEnded && !isInProgressCounter && !isPendingCounter;
    const onlyPendingCounters = !inProgressCounter && pendingCounter;

    const shouldCalculateStatus = !initiallyLoaded || !(isInProgressCounter || isPendingCounter);
    const calculatedStatus = (isAuctionEndedAndNoCounters || onlyPendingCounters) ? VEHICLE_TABS_TYPES.PENDING : VEHICLE_TABS_TYPES.ACTIVE;

    const status = shouldCalculateStatus ? calculatedStatus : newProps.auctionStatus;

    this.loadList(status);
  }

  changeStatus = (newStatus) => {
    const { auctionStatus: currentStatus, loadCounters } = this.props;
    if (currentStatus !== newStatus) {
      this.loadList(newStatus);
      loadCounters();
    }
  }

  loadList = (status) => {
    const { fetchList, setPage, perPage, changeStatus } = this.props;
    const { initiallyLoaded } = this.state;

    if (!initiallyLoaded) this.setState({ initiallyLoaded: true });

    setPage(1);
    changeStatus(status);
    fetchList({
      status,
      params: { limit: perPage, offset: 1 }
    });
    setPage(2);
  }

  renderTab = (type) => {
    const { auctionStatus, counters } = this.props
    const { [type]: counter } = counters;
    const text = type === VEHICLE_TABS_TYPES.ACTIVE ? 'In Progress' : 'Timer Ended';
    return (
      <ButtonBase
        onClick={() => this.changeStatus(type)}
      >
        <StyledTypography
          variant="title"
          isActive={auctionStatus === type}
        >
          {`${text} (${counter})`}
        </StyledTypography>
      </ButtonBase>
    );
  }

  render() {
    const { counters, countersLoaded, countersLoading } = this.props;

    if (countersLoading && countersLoaded) {
      return <CircularProgress />;
    }

    let tabs = null;

    const { [VEHICLE_TABS_TYPES.ACTIVE]: inProgressCounter, [VEHICLE_TABS_TYPES.PENDING]: pendingCounter, auction } = counters;

    const isAuctionActive = auction && auction.status === AUCTION_STATUSES.ACTIVE;
    const isAuctionEnded = auction && auction.status === AUCTION_STATUSES.ENDED;
    const isInProgressCounter = Boolean(inProgressCounter);
    const isPendingCounter = Boolean(pendingCounter);

    const isAuctionActiveAndNoCounters = isAuctionActive && !isInProgressCounter && !isPendingCounter;
    const isAuctionEndedAndNoCounters = isAuctionEnded && !isInProgressCounter && !isPendingCounter;
    const onlyInProgressCounters = isInProgressCounter && !isPendingCounter;
    const onlyPendingCounters = !isInProgressCounter && isPendingCounter;

    if (isAuctionActiveAndNoCounters || onlyInProgressCounters) {
      tabs = this.renderTab(VEHICLE_TABS_TYPES.ACTIVE);
    } else if (isAuctionEndedAndNoCounters || onlyPendingCounters) {
      tabs = this.renderTab(VEHICLE_TABS_TYPES.PENDING);
    } else if (isInProgressCounter && isPendingCounter) {
      tabs = [this.renderTab(VEHICLE_TABS_TYPES.ACTIVE), this.renderTab(VEHICLE_TABS_TYPES.PENDING)];
    }

    return tabs;
  }
}

Tabs.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  fetchList: PropTypes.func.isRequired,
  loadCounters: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  auctionStatus: PropTypes.string.isRequired,
  counters: PropTypes.object.isRequired,
  countersLoading: PropTypes.bool.isRequired,
  countersLoaded: PropTypes.bool.isRequired,
  perPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

export default withRouter(Tabs);

